import React, { useState, useEffect } from "react";
import { Card, Accordion } from "react-bootstrap";
import { Filter, Spinner, InputBox } from "../../Common";
import { ordersList, getOrdersDetails, getUsersPartnerList } from "../../api";
import { format } from "date-fns";
import styles from "./orders.module.css";
import DataTable from "./../../Common/DataTable/DataTable";
import { addDays } from "date-fns";
import { formatDateAndTime } from "./../../utils/utils";
import Offcanvas from "react-bootstrap/Offcanvas";
import { productType } from "./../../utils/utils";
import { CookieUtils } from "../../axios.config";
const orderColumns = [
  {
    Header: "Order Id",
    accessor: "orderId",
    search: false,
  },
  {
    Header: "Full Name",
    accessor: "fullname",
    search: false,
  },
  {
    Header: "Type",
    accessor: "type",
    search: false,
  },
  {
    Header: "Symbol",
    accessor: "symbol",
    search: false,
  },
  {
    Header: "Partner",
    accessor: "partnerCode",
    search: false,
  },
  {
    Header: "Category",
    accessor: "category",
    search: false,
  },
  {
    Header: "Status",
    accessor: "status",
    search: false,
  },
  {
    Header: "Created Date",
    accessor: "created",
    search: false,
  },
  {
    Header: "Last Executed Date",
    accessor: "lastExecuted",
    search: false,
  },

  {
    Header: "View Details",
    accessor: "details",
    search: false,
  },
];

function Orders() {
  const clientName = CookieUtils.get("clientName");
  const defaultPartner = clientName === "STOCKAL" ? "ALL" : clientName;
  const [partner, setPartner] = useState(defaultPartner);
  const date = new Date();
  const [startDate, setStartDate] = useState(addDays(date, -15));
  const [endDate, setEndDate] = useState(date);
  const [fetchBy, setFetchBy] = useState("");
  const [list, setList] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [partnerList, setPartnerList] = useState([]);
  const [canvasData, setCanvasData] = useState();
  const [showCanvas, setShowCanvas] = useState(false);
  const [activeKey, setActiveKey] = useState(["0"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [searchText, setSearchText] = useState("");

  const fetchByOptions = {
    "Created Date": "created",
    "Executed Date": "executedDate",
  };

  const getOrdersData = async (
    startDate,
    endDate,
    partner,
    fetchBy,
    page = 1
  ) => {
    setDataLoading(true);
    try {
      const { data: { data: { result = [], totalRecords = 0 } = {} } = {} } =
        await ordersList(
          startDate,
          endDate,
          partner,
          fetchBy,
          searchText,
          "",
          "",
          page,
          pageSize
        );

      setDataLoading(false);
      setList(result);
      setTotalPages(Math.ceil(totalRecords / pageSize));
    } catch (e) {
      setDataLoading(false);
    }
  };

  const getPartnerApi = async () => {
    try {
      const resp = await getUsersPartnerList({ appName: productType.INVESTING });
      if (resp?.data?.code === 200) {
        const partners = resp?.data?.data.map((item) => ({
          name: item.partnerName,
          code: item.partnerCd,
        }));
        setPartnerList([{ name: "ALL", code: "ALL" }, ...partners]);
      }
    } catch (error) {}
  };
  const partnerOptions =
    partnerList?.map((partner) => ({
      label: partner.name,
      value: partner.code,
    })) || [];

 useEffect(() => {
    getPartnerApi();
  }, []);
  useEffect(() => {
  const dateStart = format(startDate, "yyyy-MM-dd");
  const dateEnd = format(endDate, "yyyy-MM-dd");
  const timeoutId = setTimeout(() => {
    getOrdersData(dateStart, dateEnd, partner, fetchBy, currentPage);
  }, searchText ? 500 : 0);
  return () => clearTimeout(timeoutId);
}, [currentPage, searchText]);

  const onSubmit = () => {
    setErrorMessage("");

    if (!startDate || !endDate) {
      setErrorMessage("Please select dates.");
      return;
    }
    if (!partner) {
      setErrorMessage("Partner is required");
      return;
    }

    try {
      setCurrentPage(1);
      setList([]);
      setTotalPages(1);

      const dateStart = format(startDate, "yyyy-MM-dd");
      const dateEnd = format(endDate, "yyyy-MM-dd");

      getOrdersData(dateStart, dateEnd, partner, fetchBy, 1);
    } catch (error) {
      setErrorMessage("Invalid date format.");
    }
  };

  const fetchDetails = async (data) => {
    try {
      const { data: { data: orderData = {} } = {} } = await getOrdersDetails(
        data.orderId
      );

      if (orderData) {
        setCanvasData(orderData);
      }
    } catch (error) {}
  };

  const handleClickRow = async (data) => {
    setCanvasData(null);
    setShowCanvas(true);
    await fetchDetails(data);
  };

  const handleToggle = (key) => {
    setActiveKey((prev) =>
      prev.includes(key) ? prev.filter((tab) => tab !== key) : [...prev, key]
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.searchBox} style={{ margin: "0px 0px 10px 0px" }}>
        <InputBox
          placeholder="Search by OrderId, Symbol and Category ..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <Card className={styles.customCard}>
        <Card.Body className={styles.customCardBody}>
          <Filter
            partner={partner}
            setPartner={setPartner}
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            onSearch={onSubmit}
            errorMessage={errorMessage}
            partnerList={partnerOptions}
            fetchBy={fetchBy}
            setFetchBy={setFetchBy}
            showFetchBy={true}
            showStatus={false}
            fetchByOptions={fetchByOptions}
          />
        </Card.Body>
      </Card>

      {dataLoading ? (
        <Spinner />
      ) : (
        <>
          {Array.isArray(list) && list.length > 0 ? (
            <>
              <DataTable
                columns={orderColumns}
                list={list}
                handleClickRow={handleClickRow}
                rowClick={false}
                totalPages={totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pagination={true}
                title="Orders"
              />
            </>
          ) : (
            <p
              style={{
                color: "white",
                marginTop: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              No Data Found
            </p>
          )}
          <Offcanvas
            show={showCanvas}
            onHide={() => setShowCanvas(false)}
            placement="end"
            className={styles.offcanvas}
            backdropClassName={styles.backgroundBlur}
            style={{ color: "white" }}
          >
            <Offcanvas.Header closeButton className={styles.offcanvasHeader}>
              <Offcanvas.Title>Order Details</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {canvasData ? (
                <Accordion
                  activeKey={activeKey}
                  className={styles.accordionContainer}
                >
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className={styles.accordionHeader}>
                      Main Details
                    </Accordion.Header>
                    <Accordion.Body className={styles.accordionBody}>
                      <table className={styles.details}>
                        <tr>
                          <td className={styles.text}>Order ID:</td>
                          <td className={styles.textMuted}>
                            {canvasData.orderId || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Full Name:</td>
                          <td className={styles.textMuted}>
                            {canvasData.fullname || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Type:</td>
                          <td className={styles.textMuted}>
                            {canvasData.type || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Symbol:</td>
                          <td className={styles.textMuted}>
                            {canvasData.symbol || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Symbol Name:</td>
                          <td className={styles.textMuted}>
                            {canvasData.symbolName || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Side:</td>
                          <td className={styles.textMuted}>
                            {canvasData.side || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Status:</td>
                          <td className={styles.textMuted}>
                            {canvasData.status || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Category:</td>
                          <td className={styles.textMuted}>
                            {canvasData.category || "--"}
                          </td>
                        </tr>
                      </table>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="1" style={{ marginTop: "20px" }}>
                    <Accordion.Header
                      onClick={() => handleToggle("1")}
                      className={styles.accordionHeader}
                    >
                      Financial Details
                    </Accordion.Header>
                    <Accordion.Body className={styles.accordionBody}>
                      <table className={styles.details}>
                        <tr>
                          <td className={styles.text}>Investment Amount:</td>
                          <td className={styles.textMuted}>
                            ${canvasData.investmentAmount?.toFixed(2) || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Total Order Amount:</td>
                          <td className={styles.textMuted}>
                            ${canvasData.totalOrderAmount?.toFixed(2) || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Amount Cash:</td>
                          <td className={styles.textMuted}>
                            ${canvasData.amountCash?.toFixed(2) || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>
                            Cumulative Investment:
                          </td>
                          <td className={styles.textMuted}>
                            $
                            {canvasData.cumulativeInvestment?.toFixed(2) ||
                              "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Index Price:</td>
                          <td className={styles.textMuted}>
                            ${canvasData.indexPrice?.toFixed(2) || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>AUM Commission:</td>
                          <td className={styles.textMuted}>
                            ${canvasData.aumCommission?.toFixed(2) || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Entry Fee Commission:</td>
                          <td className={styles.textMuted}>
                            ${canvasData.entryFeeCommission?.toFixed(2) || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Total Commission:</td>
                          <td className={styles.textMuted}>
                            ${canvasData.totalCommission?.toFixed(2) || "--"}
                          </td>
                        </tr>
                      </table>
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item eventKey="2" style={{ marginTop: "20px" }}>
                    <Accordion.Header
                      onClick={() => handleToggle("2")}
                      className={styles.accordionHeader}
                    >
                      Other Details
                    </Accordion.Header>
                    <Accordion.Body className={styles.accordionBody}>
                      <table className={styles.details}>
                        <tr>
                          <td className={styles.text}>Partner Code:</td>
                          <td className={styles.textMuted}>
                            {canvasData.partnerCode || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Account No:</td>
                          <td className={styles.textMuted}>
                            {canvasData.accountNo || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Created:</td>
                          <td className={styles.textMuted}>
                            {formatDateAndTime(canvasData.created)}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Last Executed:</td>
                          <td className={styles.textMuted}>
                            {formatDateAndTime(canvasData.lastExecuted)}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Executed Date:</td>
                          <td className={styles.textMuted}>
                            {canvasData.executedDate || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Username:</td>
                          <td className={styles.textMuted}>
                            {canvasData.username || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Subscription Type:</td>
                          <td className={styles.textMuted}>
                            {canvasData.subscriptionType || "--"}
                          </td>
                        </tr>
                        <tr>
                          <td className={styles.text}>Is Rebalancing:</td>
                          <td className={styles.textMuted}>
                            {canvasData.isRebalancing ? "Yes" : "No"}
                          </td>
                        </tr>
                      </table>
                    </Accordion.Body>
                  </Accordion.Item>

                  {canvasData.stackChildOrders &&
                    canvasData.stackChildOrders.length > 0 && (
                      <Accordion.Item
                        eventKey="3"
                        style={{ marginTop: "20px" }}
                      >
                        <Accordion.Header
                          onClick={() => handleToggle("3")}
                          className={styles.accordionHeader}
                        >
                          Child Orders
                        </Accordion.Header>
                        <Accordion.Body className={styles.accordionBody}>
                          <table className={styles.details}>
                            <thead>
                              <tr>
                                <th className={styles.text}>Symbol</th>
                                <th className={styles.text}>Type</th>
                                <th className={styles.text}>Status</th>
                                <th className={styles.text}>Order No</th>
                              </tr>
                            </thead>
                            <tbody>
                              {canvasData.stackChildOrders.map(
                                (order, index) => (
                                  <tr key={index}>
                                    <td className={styles.text}>
                                      {order.symbol}
                                    </td>
                                    <td className={styles.text}>
                                      {order.type}
                                    </td>
                                    <td className={styles.text}>
                                      {order.status}
                                    </td>
                                    <td className={styles.text}>
                                      {order.orderNo}
                                    </td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </Accordion.Body>
                      </Accordion.Item>
                    )}

                  {canvasData.stocksQty &&
                    Object.keys(canvasData.stocksQty).length > 0 && (
                      <Accordion.Item
                        eventKey="4"
                        style={{ marginTop: "20px" }}
                      >
                        <Accordion.Header
                          onClick={() => handleToggle("4")}
                          className={styles.accordionHeader}
                        >
                          Stocks Quantity
                        </Accordion.Header>
                        <Accordion.Body className={styles.accordionBody}>
                          <table className={styles.details}>
                            <thead>
                              <tr>
                                <th>Symbol</th>
                                <th>Quantity</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Object.entries(canvasData.stocksQty).map(
                                ([symbol, qty], index) => (
                                  <tr key={index}>
                                    <td>{symbol}</td>
                                    <td>{qty.toFixed(8)}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </Accordion.Body>
                      </Accordion.Item>
                    )}
                </Accordion>
              ) : (
                <div
                  style={{
                    height: "100%",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Spinner animation="border" variant="light" />
                </div>
              )}
            </Offcanvas.Body>
          </Offcanvas>
        </>
      )}
    </div>
  );
}

export default Orders;
